export const TESTIMONIALS = [
  {
    id: 't1',
    quote:
      'Maharaj Ji’s guidance completely changed my career. The remedies he suggested were simple, and within 3 months I got the promotion I had waited years for.',
    name: 'Rajesh Kumar',
    loc: 'Mumbai, India · Career',
    initial: 'R',
  },
  {
    id: 't2',
    quote:
      'I was unsure about an online consultation, but my Kundli reading was so accurate. His Vastu advice brought real peace and harmony to our home.',
    name: 'Sarah Jenkins',
    loc: 'London, UK · Vastu',
    initial: 'S',
  },
  {
    id: 't3',
    quote:
      'His honest reading helped me take the right decision during a very tough business phase. Genuine Vedic wisdom with truly practical advice.',
    name: 'Amit Patel',
    loc: 'New Jersey, USA · Business',
    initial: 'A',
  },
  {
    id: 't4',
    quote:
      'The remedies were simple to follow and the results spoke for themselves — my family situation has never felt more balanced and calm.',
    name: 'Priya Nair',
    loc: 'Bengaluru, India · Family',
    initial: 'P',
  },
]
